<template>
  <div>
    <BlockUI v-if="loading" :mensaje="mensajeBlock"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-file-invoice-dollar"
      texto-titulo="Generar comprobante"
    ></TituloComponent>
    <div>
      <!-- Cliente -->
      <div class="card-outline-primary mb-3 card">
        <div class="card-header">
          <i class="fas fa-user header-icon icon-gradient bg-alternate"></i
          >Datos de cliente
        </div>
        <div class="card-body p-0">
          <div class="grid-menu grid-menu-2col" v-if="!comprobante.cliente">
            <div class="no-gutters row">
              <div class="col-12">
                <button
                  class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary opacity-7"
                  @click="modalCliente = true"
                  tabindex="1"
                >
                  <i
                    class="fas fa-user-check btn-icon-wrapper btn-icon-lg mb-3"
                  ></i
                  >Seleccionar cliente
                </button>
              </div>
            </div>
          </div>
          <div
            class="widget-content hoverable"
            tabindex="1"
            v-else
            @click="modalCliente = true"
            title="Click para cambiar cliente"
          >
            <div class="widget-content-wrapper row">
              <div class="widget-content-left col-12">
                <h5 class="widget-heading text-success">
                  {{ comprobante.cliente.nombre }}
                </h5>
                <div class="widget-subheading opacity-10 row">
                  <span class="col-sm-auto col-12 text-alternate">
                    N° Doc/CUIL:
                    <b>{{ comprobante.cliente.numero_documento | cuil }}</b>
                  </span>
                  <span class="col-sm-auto col-12">
                    IVA:
                    <b>{{
                      comprobante.cliente.responsabilidad_iva.descripcion
                    }}</b>
                  </span>
                  <span class="col-sm-auto col-12">
                    Domicilio:
                    <b>{{ comprobante.cliente.domicilio }}</b>
                  </span>
                  <span class="col-sm-auto col-12">
                    Localidad:
                    <b>{{ comprobante.cliente.localidad }}</b>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalSelectCliente
        v-if="modalCliente"
        @selectCliente="onSelectCliente"
        @cerrarModalCliente="modalCliente = false"
      ></ModalSelectCliente>
      <!-- Cabecera -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="row no-gutters">
            <div class="widget-wrapper col-lg-3">
              <div class="widget-heading opacity-10">
                <float-label label="Tipo comprobante:" clase="col-12 mb-md-0">
                  <select
                    id="forma_pago"
                    class="form-control"
                    v-model="comprobante.tipo"
                  >
                    <option value="null">Seleccione tipo</option>
                    <option value="1">Factura A</option>
                    <option value="6">Factura B</option>
                    <option value="91">Remito</option>
                    <option value="3">Crédito A</option>
                    <option value="8">Crédito B</option>
                  </select>
                </float-label>
              </div>
            </div>
            <div class="widget-wrapper col-lg-3">
              <div class="widget-heading opacity-10">
                <float-label label="Forma de pago" clase="col-12 mb-md-0">
                  <select
                    id="forma_pago"
                    class="form-control"
                    v-model="forma_pago"
                  >
                    <option value="null">Seleccione forma de pago</option>
                    <option value="Contado">Contado</option>
                    <option value="Cuenta corriente">Cuenta corriente</option>
                  </select>
                </float-label>
              </div>
            </div>

            <div class="widget-wrapper col-lg-3">
              <div class="widget-heading opacity-10">
                <float-label label="Lista" clase="col-12 mb-md-0">
                  <select
                    name="lista_id"
                    id="lista_id"
                    class="form-control"
                    v-model="lista_id"
                  >
                    <option
                      v-for="lista in listas"
                      :key="lista.id"
                      :value="lista.id"
                    >
                      {{ lista.descripcion }}
                    </option>
                  </select>
                </float-label>
              </div>
            </div>
            <div class="widget-wrapper col-lg-3" v-if="pedido.id">
              <div class="widget-heading opacity-10">
                <float-label label="Facturar día:" clase="w-100 mb-md-0">
                  <input
                    type="date"
                    id="facturar_dia"
                    class="form-control"
                    v-model="pedido.dia_facturacion"
                  />
                </float-label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Detalle -->
      <div class="card">
        <div class="card-header">
          <h4 class="text-capitalize text-secondary">Detalle</h4>
        </div>
        <div class="card-body">
          <ul class="list-group list-group-flush mb-3 detail">
            <li
              class="list-group-item hoverable"
              v-for="(detalle, i) in comprobante.detalles"
              :key="detalle.id"
              @click="clickDetalle(detalle, i)"
            >
              <div class="widget-content p-0">
                <div class="widget-content-wrapper row">
                  <div class="widget-content-left col-sm-9 col-12">
                    <h5 class="widget-heading text-primary opacity-10">
                      {{ detalle.articulo.descripcion }}
                    </h5>
                    <div class="widget-subheading opacity-10 row">
                      <span class="col-sm-auto col-6 text-center">
                        Precio:
                        <b class="text-success"
                          >${{ detalle.importe | numFormat("0,0.00") }}</b
                        >
                      </span>
                      <span class="col-sm-auto col-6 text-center">
                        Descuento:
                        <b class="text-focus">{{ detalle.descuento }}%</b>
                      </span>
                      <span class="col-sm-auto col-6 text-center">
                        Cantidad:
                        <b class="text-alternate">{{ detalle.cantidad }}</b>
                      </span>
                    </div>
                  </div>
                  <div
                    class="widget-content-right col-sm-3 text-sm-right text-center"
                  >
                    <div class="widget-numbers text-danger">
                      <span class="count-up-wrapper"
                        >${{ detalle.total | numFormat("0,0.00") }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="no-gutters row" v-if="comprobante.detalles.length <= 25">
            <div class="col-12">
              <button
                class="btn btn-outline-primary opacity-7 btn-wide btn-lg py-3 btn-block"
                @click="modalArticulo = true"
              >
                <i class="fas fa-plus mr-2"></i>Añadir detalle
              </button>
            </div>
          </div>
        </div>
      </div>
      <ModalSelectArticulo
        ref="selectArticulo"
        v-if="modalArticulo"
        @selectArticulo="onSelectArticulo"
        @cerrarModalArticulo="modalArticulo = false"
      ></ModalSelectArticulo>

      <!-- Total -->

      <div class="mb-3 card pt-0 px-3 pb-3 text-left text-md-center">
        <div class="no-gutters row">
          <div class="col-12 col-md-4">
            <div class="widget-wrapper">
              <div class="widget-heading opacity-10">
                <h3 class="mb-0 font-weight-bold">
                  Subtotal:
                  <span class="text-success"
                    >${{ comprobante.importe_neto | numFormat("0,0.00") }}</span
                  >
                </h3>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="widget-wrapper">
              <div class="widget-heading opacity-10">
                <h3 class="mb-0 font-weight-bold">
                  IVA:
                  <span class="text-success"
                    >${{ comprobante.importe_iva | numFormat("0,0.00") }}</span
                  >
                </h3>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="widget-wrapper">
              <div class="widget-heading opacity-10">
                <h3 class="mb-0 font-weight-bold">
                  Total:
                  <span class="text-success"
                    >${{
                      comprobante.importe_total | numFormat("0,0.00")
                    }}</span
                  >
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card p-2 mt-2 mb-2">
        <div class="row">
          <div class="col-md-2 order-md-1 order-4">
            <button
              class="btn btn-default btn-block mb-2 mb-md-0"
              type="button"
              @click="$router.go(-1)"
            >
              Volver
            </button>
          </div>
          <div v-if="this.pedido.id" class="col-md-2 order-md-2 order-2">
            <button
              class="btn btn-success btn-block mb-2 mb-md-0"
              type="button"
              @click="guardarPedido"
            >
              Guardar Pedido
            </button>
          </div>
          <div v-if="this.pedido.id" class="col-md-2 order-md-3 order-3">
            <button
              class="btn btn-danger btn-block mb-2 mb-md-0"
              type="button"
              @click="eliminarPedido"
            >
              Eliminar Pedido
            </button>
          </div>
          <div
            class="col-md-2 order-md-4 order-1"
            :class="this.pedido.id ? 'offset-md-4' : 'offset-md-8'"
          >
            <button
              type="button"
              @click="generarComprobante()"
              class="btn btn-block btn-info text-white mb-4 mb-md-0"
            >
              Facturar
            </button>
          </div>
        </div>
      </div>
      <EditarDetalle
        v-if="editDetalle"
        :detalle="detalleSeleccionado"
        @confirmDetalle="onConfirmDetalle"
        @cerrarEditarDetalle="editDetalle = false"
      ></EditarDetalle>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import ModalSelectCliente from "@/components/views/clientes/ModalSelectCliente";
import ModalSelectArticulo from "@/components/views/articulos/ModalSelectArticulo";
import EditarDetalle from "@/components/views/comprobantes/EditarDetalle";
import FloatLabel from "@/components/layouts/FloatLabel";
import Swal from "sweetalert2";
import Pedido from "@/models/pedido";
import Comprobante from "@/models/comprobante";
import axios from "axios";
import BlockUI from "@/components/loaders/BlockUI";

export default {
  name: "NuevoComprobante",
  components: {
    TituloComponent,
    ModalSelectCliente,
    ModalSelectArticulo,
    BlockUI,
    FloatLabel,
    EditarDetalle,
  },
  data() {
    return {
      comprobante: new Comprobante(
        null, //id
        null, //tipo
        null, //numero
        null, //cliente_tipo_doc
        null, //cliente_num_doc
        null, //fecha
        0, //importe_total
        0, //importe_neto
        0, //importe_iva
        null, //comprobante_asociado
        null, //cae
        null, //vencimiento_cae
        null, //resultado
        null, //pedido
        null, //cliente
        [], //detalle
        [], //alicuotas
      ),
      pedido: new Pedido(
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        {},
        {},
        {},
        [],
      ),
      listas: [],
      lista: null,
      lista_id: null,
      cambiado: false,
      modalCliente: false,
      forma_pago: null,
      modalArticulo: false,
      indexDetalle: null,
      detalleSeleccionado: {},
      editDetalle: false,
      loading: false,
      mensajeBlock: "Cargando",
    };
  },
  computed: {},
  watch: {
    lista_id: function() {
      if (
        this.lista_id ||
        this.lista_id !== undefined ||
        this.lista_id !== null
      ) {
        this.lista = [...this.listas].filter(
          (lista) => lista.id === this.lista_id,
        )[0];
      } else {
        this.lista = null;
      }
      this.cambiarImportes();
      this.setAlicuotas();
    },
    "comprobante.detalles": function(newValue, oldValue) {
      if (oldValue.length > 0) {
        this.cambiado = true;
      }
    },
    "pedido.dia_facturacion": function(newValue, oldValue) {
      if (oldValue) {
        this.cambiado = true;
      }
    },
  },
  mounted() {
    if (this.$route.params.pedido_id) {
      this.pedido.id = this.$route.params.pedido_id;
      this.getPedido();
    } else {
      this.getListas();
    }
    this.setTipoComprobante();
  },
  methods: {
    async getPedido() {
      this.loading = true;

      await this.getListas();
      axios
        .get("/pedidos/" + this.pedido.id)
        .then((res) => {
          if (res.data.success) {
            this.pedido = res.data.pedido;
            this.comprobante.pedido = this.pedido;
            // Clonar el cliente para evitar referencias compartidas
            this.comprobante.cliente = JSON.parse(
              JSON.stringify(this.pedido.cliente),
            );
            this.comprobante.detalles = this.pedido.detalle;
            this.comprobante.importe_total = this.pedido.total;
            this.forma_pago = this.pedido.forma_pago;
            this.lista_id = this.pedido.cliente.lista_id;
            if (this.comprobante.cliente.id != null) {
              this.lista_id = this.comprobante.cliente.lista_id;
            }
            this.setTipoComprobante();
            this.setAlicuotas();
            this.setTipoDoc();
            this.cambiado = false;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    async getListas() {
      this.loading = true;
      const res = await axios.get("/listas");
      for (let lista of res.data.data) {
        this.listas.push(lista);
      }
      if (this.pedido.id != null) {
        this.lista_id = this.pedido.lista_id;
      } else if (this.comprobante.cliente) {
        this.lista_id = this.comprobante.cliente.lista_id;
      } else {
        this.lista_id = 1;
      }
      this.loading = false;
    },
    onSelectCliente(cliente) {
      // Clonar el cliente para evitar referencias compartidas
      this.comprobante.cliente = JSON.parse(JSON.stringify(cliente));
      if (this.comprobante.cliente.id != null) {
        this.lista_id = this.comprobante.cliente.lista_id;
      }
      this.modalCliente = false;
      this.setTipoComprobante();
      this.cambiarImportes();
      this.setTipoDoc();
    },
    cambiarImportes() {
      console.log("cambiar importe");
      console.log(this.lista_id, this.lista);
      for (let detalle of this.comprobante.detalles) {
        if (this.lista && !detalle.editado) {
          console.log(this.lista_id);
          detalle.importe =
            detalle.articulo.precio_final +
            detalle.articulo.precio_final * (this.lista.porcentaje / 100);
        }
        detalle.total = parseFloat(
          (
            detalle.cantidad *
            detalle.importe *
            (1 - detalle.descuento / 100)
          ).toFixed(2),
        );
      }
    },
    async onSelectArticulo(articulo) {
      const { value: cantidad } = await Swal.fire({
        title: `Cantidad de ${articulo.descripcion}`,
        allowOutsideClick: false,
        input: "text",
        inputPlaceholder: "0",
        inputAttributes: {
          maxlength: 10,
          inputmode: "numeric",
        },
        showCancelButton: true,
        confirmButtonText: "Agregar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        preConfirm: (cantidad) => {
          if (isNaN(cantidad)) {
            Swal.showValidationMessage(`Sólo se aceptan números.`);
            return false;
          }
          if (articulo.stock < cantidad) {
            Swal.showValidationMessage(
              `Stock insuficiente, quedan ${articulo.stock} unidades.`,
            );
            return false;
          }
          this.$refs.selectArticulo.clear();
          return cantidad;
        },
      });
      if (this.comprobante.detalles.length >= 40) {
        Swal.fire({
          icon: "warning",
          title: "Listo!",
          text: `Has llegado a la cantidad máxima de items`,
        });
        this.modalArticulo = false;
      }
      if (cantidad) {
        let detalle = {};
        if (this.lista) {
          detalle.importe =
            articulo.precio_final +
            articulo.precio_final * (this.lista.porcentaje / 100);
        } else {
          detalle.importe = articulo.precio_final;
        }
        detalle.descripcion = `${articulo.descripcion}`;
        detalle.articulo = articulo;
        detalle.articulo_id = articulo.id;
        detalle.cantidad = cantidad;
        detalle.descuento = 0;
        detalle.total =
          detalle.cantidad * detalle.importe * (1 - detalle.descuento / 100);
        this.comprobante.detalles.push(detalle);
        this.comprobante.importe_total += detalle.total;
      }
      this.setAlicuotas();
    },
    setAlicuotas() {
      //importes
      let neto = 0;
      let importe_iva = 0;
      //recorrer detalles
      this.comprobante.alicuotas = [];
      for (let detalle of this.comprobante.detalles) {
        //obtener alicuotas actuales
        let existente = this.comprobante.alicuotas.filter((alicuota) => {
          return alicuota.codigo === detalle.articulo.alicuota_iva_id;
        });
        //setear totales
        let total_parcial = parseFloat(
          (
            detalle.cantidad *
            detalle.importe *
            (1 - detalle.descuento / 100)
          ).toFixed(2),
        );
        let neto_parcial = parseFloat(
          (total_parcial / (1 + detalle.articulo.iva.value)).toFixed(2),
        );
        neto += neto_parcial;
        importe_iva += parseFloat((total_parcial - neto_parcial).toFixed(2));
        //setear alicuota
        let alicuota = {
          codigo: detalle.articulo.alicuota_iva_id,
          importe_base: neto_parcial,
          importe_iva: parseFloat((total_parcial - neto_parcial).toFixed(2)),
        };
        //añadir valores nuevos
        if (existente.length === 0) {
          this.comprobante.alicuotas.push(alicuota);
        } else {
          existente[0].importe_base = parseFloat(
            (existente[0].importe_base + alicuota.importe_base).toFixed(2),
          );
          existente[0].importe_iva = parseFloat(
            (existente[0].importe_iva + alicuota.importe_iva).toFixed(2),
          );
        }
      }
      this.comprobante.importe_neto = parseFloat(neto.toFixed(2));
      this.comprobante.importe_iva = parseFloat(importe_iva.toFixed(2));
      this.comprobante.importe_total = parseFloat(
        (neto + importe_iva).toFixed(2),
      );
    },
    setTipoComprobante() {
      if (this.comprobante.cliente) {
        if (
          this.comprobante.cliente.responsabilidad_iva_id === 1 ||
          this.comprobante.cliente.responsabilidad_iva_id === 6
        ) {
          this.comprobante.tipo = 1;
        } else {
          this.comprobante.tipo = 6;
        }
      } else {
        this.comprobante.tipo = 6;
      }
    },
    setTipoDoc() {
      if (this.comprobante.cliente.numero_documento.toString().length === 11) {
        this.comprobante.cliente_tipo_doc = 80;
      } else if (
        this.comprobante.cliente.numero_documento.toString().length === 8 ||
        this.comprobante.cliente.numero_documento.toString().length === 7
      ) {
        this.comprobante.cliente_tipo_doc = 96;
      } else {
        this.comprobante.cliente_tipo_doc = 99;
      }
      this.comprobante.cliente_num_doc = this.comprobante.cliente.numero_documento;
    },
    setDenominacion() {
      let letra = "";
      switch (parseInt(this.comprobante.tipo)) {
        case 1:
        case 3:
          letra = "A";
          break;
        case 6:
        case 8:
          letra = "B";
          break;
        case 91:
          letra = "R";
          break;
      }
      return `${letra}${this.comprobante.numero.toString().padStart(8, "0")}`;
    },
    async generarComprobante() {
      if (!(await this.validacion())) {
        return false;
      }
      if (this.loading) {
        return false;
      }
      this.loading = true;
      if (this.comprobante.tipo !== 91) {
        this.mensajeBlock = "Consultando a AFIP";
      }
      this.comprobante.importe_total = parseFloat(
        this.comprobante.importe_total.toFixed(2),
      );
      this.comprobante.importe_neto = parseFloat(
        this.comprobante.importe_neto.toFixed(2),
      );
      this.comprobante.importe_iva = parseFloat(
        this.comprobante.importe_iva.toFixed(2),
      );

      // Si hay un pedido y el cliente cambió, actualizar el pedido con el nuevo cliente
      if (
        this.pedido.id &&
        this.pedido.cliente_id != this.comprobante.cliente.id
      ) {
        this.comprobante.pedido.cliente_id = this.comprobante.cliente.id;
        this.comprobante.pedido.cliente = this.comprobante.cliente;
      }

      axios
        .post("/comprobantes", this.comprobante)
        .then((res) => {
          if (res.data.success) {
            let comprobante = res.data.comprobante;
            let errores = res.data.errores;
            let observaciones = res.data.observaciones;
            let eventos = res.data.eventos;
            if (
              comprobante.resultado === "A" ||
              comprobante.resultado === "X"
            ) {
              this.comprobante.id = comprobante.id;
              this.comprobante.numero = comprobante.numero;
              this.guardarMovimiento();
            } else {
              if (errores.length > 0) {
                Swal.fire({
                  icon: "error",
                  title: "Oopss..",
                  text: `${errores[0].descripcion}`,
                });
              } else if (observaciones.length > 0) {
                Swal.fire({
                  icon: "error",
                  title: "Oopss..",
                  text: `${observaciones[0].descripcion}`,
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oopss..",
                  text: `No se pudo generar el comprobante`,
                });
              }
            }
            if (eventos.length > 0) {
              Swal.fire({
                icon: "warning",
                title: "",
                text: `${eventos[0].descripcion}`,
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Oopss..",
              text: `${res.data.mensaje}`,
            });
          }
        })
        .catch((error) => {
          // Si es un error 422, es un comprobante rechazado por AFIP
          if (error.response && error.response.status === 422) {
            const data = error.response.data;
            if (data.errores && data.errores.length > 0) {
              Swal.fire({
                icon: "error",
                title: "Comprobante rechazado por AFIP",
                text: `${data.errores[0].descripcion}`,
              });
            } else if (data.observaciones && data.observaciones.length > 0) {
              Swal.fire({
                icon: "error",
                title: "Comprobante rechazado por AFIP",
                text: `${data.observaciones[0].descripcion}`,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Comprobante rechazado por AFIP",
                text: data.mensaje || "El comprobante fue rechazado",
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Oopss..",
              text: `No se pudo generar el comprobante`,
            });
          }
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarMovimiento() {
      let movimiento = {
        comprobante_id: this.comprobante.id,
        denominacion: this.setDenominacion(),
        cliente_id: this.comprobante.cliente.id,
        forma_pago: this.forma_pago,
        tipo: "Venta",
        total: this.comprobante.importe_total,
        detalles: this.comprobante.detalles,
      };
      let data = {
        movimiento: movimiento,
        pedido: this.comprobante.pedido,
      };
      if (this.pedido.id) {
        data.user_id = this.pedido.user_id;
      } else {
        data.user_id = this.$store.state.auth.user.id;
      }
      this.loading = true;
      if (this.comprobante.tipo != 91) {
        this.mensajeBlock = "Guardando información";
      }
      axios
        .post("/movimientos", data)
        .then((res) => {
          // console.log(res);
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.movimiento.denominacion} se guardó con éxito.`,
            });
            this.$router.push({ name: "ListarPedidosPendientes" });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oopss..",
              text: `${res.mensaje}`,
            });
          }
        })
        .catch((error) => {
          console.log("error");
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            html: `<p>No se ha podido completar la operación.</p><p>${error
              .response?.data?.message ||
              error.response?.data?.error ||
              error?.message ||
              error}</p>`,
          });

          this.loading = false;
        });
    },
    clickDetalle(detalle, index) {
      Swal.fire({
        title: detalle.articulo.descripcion,
        text: "¿Desea editar o eliminar?",
        showCancelButton: true,
        confirmButtonText: "Editar",
        cancelButtonText: "Eliminar",
        confirmButtonColor: "#f7b924",
        cancelButtonColor: "#d33",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.indexDetalle = index;
          this.detalleSeleccionado = { ...detalle };
          this.editDetalle = true;
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          this.comprobante.detalles.splice(index, 1);
          this.setAlicuotas();
        }
      });
    },
    onConfirmDetalle(detalle) {
      this.comprobante.detalles[this.indexDetalle] = detalle;
      this.indexDetalle = null;
      this.editDetalle = false;
      this.cambiado = true;
      this.cambiarImportes();
      this.setAlicuotas();
    },
    async validacion() {
      if (this.pedido.id) {
        try {
          const response = await axios.get(
            "/pedidos/" + this.$route.params.pedido_id + "/check-status",
          );
          if (response.data.estado !== "pendiente") {
            Swal.fire("Oops!", "El pedido ya fue facturado", "warning");
            return false;
          }
        } catch (e) {
          Swal.fire(
            "Oops!",
            "Ocurrió un error al checkear si el pedido ya fue facturado",
            "warning",
          );
          return false;
        }
      }
      if (this.forma_pago == null) {
        Swal.fire("Oops!", "Debe seleccionar la forma de pago", "warning");
        return false;
      }
      if (this.comprobante.tipo == null) {
        Swal.fire(
          "Oops!",
          "Debe seleccionar el tipo de comprobante",
          "warning",
        );
        return false;
      }
      if (this.comprobante.detalles.length === 0) {
        Swal.fire("Oops!", "Debe añadir detalles al pedido", "warning");
        return false;
      }
      return true;
    },
    eliminarPedido() {
      Swal.fire({
        title: "¿Estás seguro?",
        text: `¿Deseas eliminar el pedido de manera permanente?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          axios
            .delete("/pedidos/" + this.pedido.id)
            .then(() => {
              Swal.fire("Eliminado", `Se ha eliminado con éxito.`, "success");
              this.$router.push({ name: "ListarPedidosPendientes" });
            })
            .catch((err) => {
              Swal.fire("Eliminado", `ERROR: ${err}`, "warning");
            })
            .finally(() => (this.loading = false));
        }
      });
    },
    guardarPedido() {
      if (
        this.cambiado ||
        this.pedido.lista_id != this.lista_id ||
        this.pedido.cliente_id != this.comprobante.cliente.id
      ) {
        this.pedido.lista_id = this.lista_id;

        // this.pedido.user_id = this.$store.state.auth.user.id;
        this.pedido.cliente_id = this.comprobante.cliente.id;
        this.pedido.cliente = this.comprobante.cliente;
        this.pedido.detalles = this.comprobante.detalles;
        this.pedido.total = this.comprobante.importe_total;
        this.loading = true;
        axios
          .put("pedidos/" + this.pedido.id, this.pedido)
          .then((res) => {
            if (res.data.success) {
              Swal.fire("Guardado", `Se ha guardado con éxito.`, "success");
              this.$router.push({ name: "ListarPedidosPendientes" });
            }
          })
          .catch((err) => {
            Swal.fire("Eliminado", `ERROR: ${err}`, "warning");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        Swal.fire(
          "No es necesario",
          `No se realizaron cambios en el pedido`,
          "warning",
        );
      }
    },
  },
};
</script>
